import React, { useEffect, useState } from 'react';
import { graphql } from "gatsby";
import { BgImage } from "gbimage-bridge";
import { Box, Heading } from "theme-ui";
import TestimonialCarousal from './testimonialCarousal';

export const query = graphql`
fragment ContentfulTestimonialSectionFragment on ContentfulTestimonialSection {
    id
    backgroundColor
    backgroundImage {
        gatsbyImageData
      }
    heading
    headingAs
    testimonialCards {
      id
      clientDesignation
      clientImageAltText
      clientName
      clientImage {
        gatsbyImageData
      }
      description {
        raw
      }
      companyLogo {
        gatsbyImageData
      }
      companyLogoAltText
      
    }
}
`;

const Testimonial = ({ sectionContent }) => {

    const { backgroundColor, backgroundImage, heading, headingAs, testimonialCards } = sectionContent;
    const [domLoaded, setDomLoaded] = useState(false);
    useEffect(() => {
      setDomLoaded(true);
    }, []);

    return (
        <Box sx={{ backgroundColor: backgroundColor && backgroundColor}}>
           {domLoaded && (
            <BgImage image={backgroundImage?.gatsbyImageData} style={{ marginInline:"auto", backgroundSize: '', backgroundPosition: '', backgroundRepeat: '', transition:''}} className="testimonial-img">
                {heading && <Heading as={headingAs} sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center', paddingTop: '70px' }}>{heading}</Heading>}
                {testimonialCards && <Box sx={{padding:'70px 0'}}> <TestimonialCarousal carousalData={testimonialCards} /></Box>}
            </BgImage>
            )}
        </Box>
    );

};
export default Testimonial;
